/**
 * useIsDemoBrand — single source of truth for "is this account allowed to
 * see the rich Lumina-style demo content?"
 *
 * Qualifies:
 *   • investor@wave.app                    — Aurora Labs investor preview.
 *   • admin@momager.com                    — Lumina master admin (legacy /demo).
 *   • any @wave-demo.app email             — the 12 presenter-v1 demo brands
 *                                            (Vector Pictures, Apex, Helix,
 *                                            Skyline, Grandburger, etc.).
 *
 * Every other brand (real signups) MUST NOT see Lumina-specific mock data.
 */
import { useAuth } from '../contexts/AuthContext';

const DEMO_EMAILS = new Set(['investor@wave.app', 'admin@momager.com']);

export function useIsDemoBrand() {
  const { user } = useAuth();
  if (!user || typeof user !== 'object') return false;
  const email = (user.email || '').toLowerCase();
  return DEMO_EMAILS.has(email) || email.endsWith('@wave-demo.app');
}

/** Brand name we should show in headers/copy. Falls back to a neutral label
 *  for fresh signups who haven't filled in brand_name yet. */
export function useBrandLabel() {
  const { user } = useAuth();
  if (!user || typeof user !== 'object') return 'Your Brand';
  return user.brand_name || user.company_name || 'Your Brand';
}
